import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'

import { EEIIActionButtons, EEIIPanel, useEEIICalls } from '../../../features/eeii-detail'
import { PageDisplayer } from '../../../ui'
import { useCombos } from '../../../features/combos'

export const EEIIDetail = () => {
  const { getEI } = useEEIICalls()
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  useCombos(['cod_zona_zeus'], ['cod_zona_zeus'])
  useCombos(['cnae'], ['cnae'])

  const [companyData, setCompanyData] = useState({})
  const [loading, setLoading] = useState(true)

  const getEIData = () => {
    getEI(id).then(({ data }) => {
      setCompanyData(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    getEIData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGoBack = () => {
    const prevSearch = location.state?.prevSearch || ''
    const basePath = location.pathname.includes('eepp') ? '/eepp' : '/eeii'
    navigate(basePath + prevSearch)
  }

  return (
    <PageDisplayer loading={loading} handleGoBack={handleGoBack} textGoBack={'Atrás'}>
      <EEIIActionButtons {...{ companyData }} />
      <EEIIPanel {...{ companyData, getEIData }} />
    </PageDisplayer>
  )
}

export default EEIIDetail
